export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
  // JavaScript to be fired on the home page, after the init JS
  
    var sections = document.querySelectorAll('.observe-section');
    var sectionNav = document.querySelector('.section-nav');
    sections.forEach(function(section){
      sectionNav.insertAdjacentHTML('beforeend','<a id="nav-'+ section.id +'" href="#' + section.id + '" class="section-nav-circle"></a>');
    });

    let options = {
      root: document.querySelector('#scrollArea'),
      rootMargin: '100px',
      threshold: .8,
    }
    var observer = new IntersectionObserver ((entries) => {
      entries.forEach(function(entry){
        var element_id = '#nav-' + entry.target.id;
        var current_element = document.querySelector(element_id);
        var sectionNavCircles = document.querySelectorAll('.section-nav-circle');
        if(entry.isIntersecting === true) {
          sectionNavCircles.forEach(function(sectionNavCircle){
            sectionNavCircle.style.cssText = 'background: #fff; width: 8px; height: 8px;';
          }); 
          current_element.style.cssText = 'background: #FFA400; width: 12px; height: 12px;';
          $('.home-line-items').removeClass('animate');
          if(entry.target.id == 'home-line-items') {
            $('.home-line-items').addClass('animate');
          }
          $('.home-arch').removeClass('animate');
          if(entry.target.id == 'home-arch') {
            $('.home-arch').addClass('animate');
            setTimeout(function() {
              $('.home-arch').css('pointer-events','all');
            }, 2000)
          }
        }
        // console.log(entry);
        // console.log(element_id);
        // console.log(current_element);
      });
    }, options);
    $(window).on('load', function() {
      //add video to lightbox
      var video = '<iframe width="1120" height="630" src="https://www.youtube.com/embed/OlcYORQNozg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>';
      $('.video-lightbox').append(video);
    });

    $(window).load(function(){

      //initialize intersection observer
      sections.forEach(function(section){
        observer.observe(section);
      });

      //scroll to next section arrows
      $('.more-arrow').each(function(){
        var next_section = $(this).closest('section').next('section');
        if(next_section.css('display') != 'none') {
          var id_selector = '#' + $(this).closest('section').next('section').attr('id');
          $(this).attr('href', id_selector);
        }
      });

      //hover button width hack
      $('.bottom-left-button .blurb').width($('.bottom-left-button .main').width() + $('.bottom-left-button .sub').width() );
      $('.bottom-right-button .blurb').width($('.bottom-right-button .main').width() + $('.bottom-right-button .sub').width() );

      //video lightbox
      $('.video-popup').click(function(){
        $('.video-lightbox').addClass('active');
        $('html, body').css('overflow', 'hidden');
      });

      $('.video-lightbox-close').click(function() {
        $('.video-lightbox').removeClass('active');
        $('html, body').css('overflow', 'unset');
      });
    });

    //arch
    $('.arch-item').click(function(){
      $('.arch-container').addClass('selected');
      $('.centerer').addClass('selected');
      //remove text
      $('.arch-text').slideUp();
      //remove other arches
      // $('.arch-item').addClass('fade-out');
      // //don't remove the arch we just selected
      // $(this).removeClass('fade-out');
      // add this class to prevent hover blinking
      $('.arch-item').removeClass('active');
      $(this).addClass('active');
      // //fade out the main container after initial animation
      // setTimeout(function() {
      //   $('.arch-container').addClass('fade-out');
      // }, 1500);
      //fade in the selected container after everything
      var selected_class = $(this).attr('class');

      //first arch is selected
      if(selected_class.includes('arch-1')) {
        // setTimeout(function() {
        //   $('.arch-item').removeClass('fade-out active');
        //   $('#hospital-arch-container').addClass('fade-in');
        //   //hide all other arch containers
        // }, 3000);
        // setTimeout(function(){
        //   $('.arch-container').addClass('hidden');
        //   $('.arch-container').removeClass('fade-out');
        //   $('#hospital-arch-container').removeClass('hidden fade-in fade-out');
        //   $('#hospital-arch-text').slideToggle();
        // }, 4500);
        setTimeout(function() {
          console.log('slideToggle arch1');
          $('#hospital-arch-text').slideToggle();
        }, 500);
      }

      //second arch is selected
      if(selected_class.includes('arch-2')) {
        // setTimeout(function() {
        //   $('.arch-item').removeClass('fade-out active');
        //   $('#physician-arch-container').addClass('fade-in');
        //   //hide all other arch containers
        // }, 3000);
        // setTimeout(function(){
        //   $('.arch-container').addClass('hidden');
        //   $('.arch-container').removeClass('fade-out');
        //   $('#physician-arch-container').removeClass('hidden fade-in fade-out');
        //   $('#physician-arch-text').slideToggle();
        // }, 4500);
        setTimeout(function() {
          $('#physician-arch-text').slideToggle();
        }, 500);
      }

      //first arch is selected
      if(selected_class.includes('arch-3')) {
        // setTimeout(function() {
        //   $('.arch-item').removeClass('fade-out active');
        //   $('#patient-arch-container').addClass('fade-in');
          //hide all other arch containers
        // }, 3000);
        // setTimeout(function(){
        //   $('.arch-container').addClass('hidden');
        //   $('.arch-container').removeClass('fade-out');
        //   $('#patient-arch-container').removeClass('hidden fade-in fade-out');
        //   $('#patient-arch-text').slideToggle();
        // }, 4500);
        setTimeout(function() {
          $('#patient-arch-text').slideToggle();
        }, 500);
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js